import { defineMessages } from "react-intl";

import {
	igGMessages,
	validator
} from "lib/build/forms/ktx/basic-registration-data/viral-serology/toxoplasma";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	toxoplasma: {
		id: "ktx.toxoplasma.title",
		defaultMessage: "Toxoplazma"
	},
	igg: {
		id: "ktx.toxoplasma.field.igg",
		defaultMessage: "IgG"
	},
	igm: {
		id: "ktx.toxoplasma.field.igm",
		defaultMessage: "IgM"
	}
});

const fields: { [key: string]: FieldData } = {
	igG: {
		type: "field",
		path: ["igG"],
		label: messages.igg,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: igGMessages } }
	},
	igM: {
		type: "field",
		path: ["igM"],
		label: messages.igm,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: igGMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.igG }] },
		{ columns: [{ width: 12, field: fields.igM }] }
	]
};

export const node: LeafNode = {
	id: "ktx_toxoplasma",
	value: {
		schemaId: "toxoplasma",
		title: messages.toxoplasma,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
